import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { totalBonuses, totalVolumes } from '../data/offer';
export function GuaranteeSection() {
  return <section className="border-t border-white/5 bg-carbon py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-114" data-mp="9ttgc9z21wy4">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-115" data-mp="etplicjhnuf9">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-3xl border-2 border-lava bg-petrol p-8 shadow-2xl shadow-black/40 sm:p-12" data-id="element-116" data-mp="jsiqthomgf4c">
          <span className="inline-flex rounded-full border border-lava bg-carbon p-4 text-lava" data-id="element-117" data-mp="xkgsj7g078qh">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-118" data-mp="12jjyqv7pzl01" />
          </span>
          <h2 id="guarantee-title" className="mt-6 font-display text-4xl font-bold text-lava" data-id="element-119" data-mp="17hv874u3rthq">
            Complete 7-day guarantee
          </h2>
          <p className="mt-4 leading-relaxed text-muted" data-id="element-120" data-mp="25ti5kiflimzh">
            Open all {totalVolumes} volumes. Review all {totalBonuses} bonuses. Use them in your most challenging
            geothermal energy class this week.
          </p>
          <p className="mt-3 leading-relaxed text-muted" data-id="element-121" data-mp="1vvkfdpe6eg48">
            If you feel your students didn't respond better or the materials didn't save you hours of work:
          </p>
          <p className="mt-6 rounded-xl border border-energy/50 bg-carbon px-5 py-4 text-lg font-extrabold text-energy" data-id="element-122" data-mp="2ohn152m3n1n7">
            We refund 100% of your money. No questions. No forms. No complications.
          </p>
          <p className="mt-5 text-sm leading-relaxed text-muted" data-id="element-123" data-mp="2eq8y4kuxvjpb">
            Because if this teacher ready doesn't deliver the value we promise, we don't want to keep your money.
          </p>
        </motion.div>
      </div>
    </section>;
}